import _toConsumableArray from "/home/runner/work/design/design/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import React from 'react';
import styled from 'styled-components';
import { useSSRSafeId } from '../..';
import { get } from '../../constants';
import { Slot } from './ChoiceFieldset';
import ChoiceFieldsetListContext from './ChoiceFieldsetListContext';
var List = styled.ul.withConfig({
  displayName: "ChoiceFieldsetList__List",
  componentId: "sc-o960a8-0"
})(["display:flex;flex-direction:column;list-style:none;margin:0;padding:0;> li + li{margin-top:", ";}"], get('space.2'));
var getSelectedCheckboxes = function getSelectedCheckboxes(value, checked, selectedValues, selectionVariant) {
  if (checked) {
    return selectionVariant === 'multiple' ? [].concat(_toConsumableArray(selectedValues), [value]) : [value];
  }
  return selectedValues.filter(function (selectedValue) {
    return selectedValue !== value;
  });
};
var ChoiceFieldsetList = function ChoiceFieldsetList(_ref) {
  var selectionVariant = _ref.selectionVariant,
    children = _ref.children;
  var ssrSafeUniqueName = useSSRSafeId();
  return /*#__PURE__*/React.createElement(Slot, {
    name: "ChoiceList"
  }, function (_ref2) {
    var name = _ref2.name,
      onSelect = _ref2.onSelect,
      disabled = _ref2.disabled,
      _ref2$selected = _ref2.selected,
      selected = _ref2$selected === void 0 ? [] : _ref2$selected;
    return /*#__PURE__*/React.createElement(ChoiceFieldsetListContext.Provider, {
      value: {
        disabled: disabled,
        selected: selected,
        name: name || ssrSafeUniqueName,
        onChange: function onChange(e) {
          var updatedSelections = getSelectedCheckboxes(e.currentTarget.value, e.currentTarget.checked, selected, selectionVariant);
          onSelect && onSelect(updatedSelections);
        },
        selectionVariant: selectionVariant
      }
    }, /*#__PURE__*/React.createElement(List, null, React.Children.map(children, function (child, i) {
      return /*#__PURE__*/React.createElement("li", {
        key: i
      }, child);
    })));
  });
};
ChoiceFieldsetList.displayName = "ChoiceFieldsetList";
ChoiceFieldsetList.defaultProps = {
  selectionVariant: 'single'
};
export default ChoiceFieldsetList;